import toPlaintext from 'quill-delta-to-plaintext';

export default function calculateQuillLength(functions) {
    let text = toPlaintext(functions);
    text = text.trim();
    return text.length > 0 ? text.split(/\s+/).length : 0;
}
